import { useEffect, useRef } from "react";
import { withBase } from "../../siteInfo";
import Reveal from "../../motion/Reveal";
import { gsap, prefersReducedMotion } from "../../motion/gsap";

const photos = [
  ["/images/campus/care-1.jpg", "OPD consultation"],
  ["/images/campus/room-2.jpg", "General ward, curtained beds"],
  ["/images/campus/room-1.jpg", "Private room, attendant bench"],
  ["/images/campus/lab-3.jpg", "Sample processing"],
  ["/images/campus/room-3.jpg", "Inpatient area"],
  ["/images/campus/room-4.jpg", "Another inpatient room"],
  ["/images/campus/room-5.jpg", "Bed prepared for a patient"],
  ["/images/campus/care-2.jpg", "Care at the bedside"],
  ["/images/campus/lab-1.jpg", "Laboratory bench"],
  ["/images/campus/lab-2.jpg", "Diagnostic area"],
  ["/images/campus/care-3.jpg", "Clinical care"],
  ["/images/campus/room-6.jpg", "Ward bed"],
];

const Gallery = () => {
  const root = useRef(null);

  useEffect(() => {
    const el = root.current;
    if (!el || prefersReducedMotion()) return undefined;

    const ctx = gsap.context(() => {
      gsap.utils.toArray("figure").forEach((fig) => {
        gsap.from(fig, {
          y: 36,
          opacity: 0,
          duration: 0.7,
          ease: "power2.out",
          scrollTrigger: {
            trigger: fig,
            start: "top 90%",
          },
        });
      });
    }, el);

    return () => ctx.revert();
  }, []);

  return (
    <section className="section" id="gallery">
      <div className="wrap">
        <Reveal className="section-head">
          <p className="kicker">
            <span>05</span> The building
          </p>
          <h2>Rooms, OPD, and the lab — photographed here.</h2>
          <p>
            These pictures are from the hospital. Photographs in the health library
            are illustrative and labelled as such.
          </p>
        </Reveal>
        <div className="gallery" ref={root}>
          {photos.map(([src, alt]) => (
            <figure key={src}>
              <img src={withBase(src)} alt={alt} />
              <figcaption>{alt}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
